import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { altoonaConfig } from "./data";

export default function AltoonaPage() {
  return <CityPageTemplate config={altoonaConfig} />;
}